import Cookies from 'universal-cookie';

function logout() {
  // return new Promise((resolve, reject) => {
  //   setTimeout(resolve, 3000);
  // });
  const cookies = new Cookies();
  cookies.remove('corporate', { path: '/' });
  cookies.remove('jp_idtoken', { path: '/' });
  cookies.remove('jp_refreshtoken', { path: '/' });
  cookies.remove('jp_accesstoken', { path: '/' });
  // return axios.post('/webLogOut');
}

export default logout;
